import axios from 'axios';
import Url from '../constants/Url';

class OAuthApi {
    getOAuth(params) {
        return axios
            .get(Url().GET_OAUTH, {params})
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getOAuth:', ex.message);
                throw ex;
            });
    }

    getOAuthLink(platform) {
        const params = {platform};
        return axios
            .get(Url().GET_OAUTH_LINK, {params})
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getOAuthLink:', ex.message);
                throw ex;
            });
    }
}

export default new OAuthApi();
